import React from "react";

const milestones = [
  {
    year: "2022–2023",
    title: "Our Humble Beginnings",
    description:
      "We cherish our humble beginnings as they mark the foundation of our journey. Small Start, Big Dreams - Our Journey Beyond Boundaries.",
    image: "./data/images/1.jpg",
  },
  {
    year: "March 2023",
    title: "An Agency is Born",
    description:
      "The Birth of an Agency: Where Our Story Begins. Our agency was born from creativity and passion.",
    image: "./data/images/2.jpg",
  },
  {
    year: "March 2024",
    title: "Transition to Full Service",
    description:
      "We embrace full-service excellence, expanding our capabilities to better serve our clients.",
    image: "./data/images/3.jpg",
  },
  {
    year: "March 2025 - 2026",
    title: "Phase Two Expansion",
    description:
      "We're growing and getting better, reaching new opportunities and making a bigger impact.",
    image: "./data/images/4.jpg",
  },
];

export default function AboutMe() {
  return (
    <section className="ab4s-about-section" id="AboutMe">

      <div className="ab4s-about-glow ab4s-glow-one"></div>
      <div className="ab4s-about-glow ab4s-glow-two"></div>

      <div className="container">

        {/* Header */}
        <div className="ab4s-about-header">

          <span className="ab4s-about-eyebrow">
            ABOUT ALPHABETA4SUCCESS
          </span>

          <h3>
            About <span>Us</span>
          </h3>

          <div className="ab4s-about-line"></div>

          <p>
            At <strong>AlphaBeta4Success</strong>, our distinctive approach
            in one-to-one and small group online classes is dedicated to
            fostering the holistic development of children. We believe in
            personalised attention, guiding each child to unlock their
            full potential.
          </p>
        </div>

        {/* Journey */}
        <div className="ab4s-compact-journey">
          <div className="ab4s-journey-title">
            <span>OUR JOURNEY</span>
            <h3>
              Growing <strong>Together</strong>
            </h3>
          </div>

          <div className="ab4s-timeline">

            {milestones.map((item, index) => (
              <div
                className="ab4s-timeline-row"
                key={item.year}
              >

                {/* Year */}
                <div className="ab4s-timeline-year">
                  <span>{item.year}</span>
                </div>

                {/* Line + image */}
                <div className="ab4s-timeline-marker">

                  <div className="ab4s-timeline-dot"></div>

                  <div className="ab4s-timeline-image">
                    <img
                      src={item.image}
                    />
                  </div>

                </div>

                {/* Content */}
                <div className="ab4s-timeline-card">

                  <div className="ab4s-timeline-number">
                    0{index + 1}
                  </div>

                  <h4>{item.title}</h4>

                  <p>{item.description}</p>

                  <span className="ab4s-timeline-arrow">
                    →
                  </span>

                </div>

              </div>
            ))}

          </div>

        </div>


        {/* Footer */}
        <div className="ab4s-story-footer">

          <div className="ab4s-story-icon">
            ✦
          </div>

          <div>
            <strong>Be Part of Our Story</strong>
            <span>
              Every success begins with a journey.
            </span>
          </div>

        </div>

      </div>

    </section>
  );
}